import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class NwOnboardingLocationComponent extends Component {
  @tracked googleGl = 'US';
  @tracked googleHl = 'en';
  googlePlace = null;
}
